export var AuthRestrictionMode;
(function (AuthRestrictionMode) {
    AuthRestrictionMode[AuthRestrictionMode["NONE"] = 0] = "NONE";
    AuthRestrictionMode[AuthRestrictionMode["ALLOWED_DOMAINS"] = 1] = "ALLOWED_DOMAINS";
})(AuthRestrictionMode || (AuthRestrictionMode = {}));
//# sourceMappingURL=auth-restriction.i.js.map